:host {
  --uui-input-title-color: var(--uui-theme-secondary-400);
  --uui-input-title-error-color: var(--uui-theme-error-600);
  --uui-input-title-warning-color: var(--uui-theme-warning-600);
  --uui-input-title-margin-bottom: 0.25rem;
}

:host {
  font-family: var(--uui-primary-font-family);
  font-size: var(--uui-default-font-size);
  font-weight: var(--uui-font-weight-bold);
  line-height: var(--uui-sm-line-height);
  color: var(--uui-input-title-color);
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
}

.label {
  margin-right: auto;
  margin-bottom: var(--uui-input-title-margin-bottom);
}

.error {
  color: var(--uui-input-title-error-color);
}

.warning {
  color: var(--uui-input-title-warning-color);
}

.disabled {
  opacity: var(--uui-disabled-opacity);
}

.icon {
  cursor: pointer;
}

.icon.hide-icon {
  display: none;
}

.uui-input-title-icon {
  display: inline-block;
  height: 1rem;
  overflow: visible;
  vertical-align: -0.125em;
  font-size: var(--uui-default-font-size);
  fill: var(--uui-input-title-color);
}

.uui-input-title-icon .error {
  fill: var(--uui-input-title-error-color);
}

.uui-input-title-icon .warning {
  fill: var(--uui-input-title-warning-color);
}

[disabled] {
  opacity: var(--uui-disabled-opacity);
  cursor: not-allowed;
}
